import { Paragraph } from '@vimeo/iris/typography';

export default function Teams() {
  return (
    <div>
      <Paragraph size="2">
        <em>Teams</em> are groups of Vimeo members.
      </Paragraph>

      <Paragraph size="2">Use the API to complete the following tasks:</Paragraph>
    </div>
  );
}
